var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.303 16.403c.03.125.81 3.041 5.197 3.041 4.388 0 5.167-2.916 5.198-3.04a.346.346 0 00-.164-.385.35.35 0 00-.417.053c-.013.013-1.357 1.29-4.617 1.29s-4.604-1.277-4.616-1.29a.348.348 0 00-.416-.055.348.348 0 00-.165.386zM8.334 11.805c.959 0 1.736-1.088 1.736-2.43s-.777-2.43-1.736-2.43c-.96 0-1.736 1.088-1.736 2.43s.777 2.43 1.736 2.43zM16.667 11.805c.959 0 1.736-1.088 1.736-2.43s-.777-2.43-1.736-2.43c-.96 0-1.736 1.088-1.736 2.43s.777 2.43 1.736 2.43z",
    fill: "#664500"
  })));
}
export default SvgSmile;